import {createNewDelivery} from "./apiService"
export const createBookingHandler = async (deliveryDetails) => {
    
    let requestBody = {
        otherData : {
            "start_country": "SG",
            "priceID":deliveryDetails.priceId,
            "end_country": "SG",
            "price" : deliveryDetails.tripFare,
            "price_original": deliveryDetails.tripFare,
            "price_type": 9,
            "trip_type": "RS",
            "rideStartTime": deliveryDetails.rideStartTime !== '' ? deliveryDetails.rideStartTime : Date.now(),
            "distance": deliveryDetails.distance,
            "note": "",
            "map_route": deliveryDetails.geometry,
            "payment": {
                "value": deliveryDetails.paymentMethod.brand === "RYDE" ? `${deliveryDetails.paymentMethod.brand} ${deliveryDetails.paymentMethod.currency} ${deliveryDetails.paymentMethod.balance}`: `${deliveryDetails.paymentMethod.brand} ${deliveryDetails.paymentMethod.exp_month}/${deliveryDetails.paymentMethod.exp_year} ${deliveryDetails.paymentMethod.last4}`,
                "label": deliveryDetails.paymentMethod.brand === "RYDE" ? `${deliveryDetails.paymentMethod.brand} ${deliveryDetails.paymentMethod.currency} ${deliveryDetails.paymentMethod.balance}`: `${deliveryDetails.paymentMethod.brand} ${deliveryDetails.paymentMethod.exp_month}/${deliveryDetails.paymentMethod.exp_year} ${deliveryDetails.paymentMethod.last4}`,
                "type": 1,
                "token": deliveryDetails.paymentMethod.source
            }

        },
        data : {
            pickup: [
                {
                    "postal": deliveryDetails.pickUpLocation.postalCode,
                    "name":  deliveryDetails.pickUpLocation.contactName,
                    "number": deliveryDetails.pickUpLocation.contactNumber,
                    "notes": "",
                    "floor": deliveryDetails.pickUpLocation.floor,
                    "unit": deliveryDetails.pickUpLocation.unitNumber,
                    "latitude": deliveryDetails.pickUpLocation.latitude,
                    "longitude": deliveryDetails.pickUpLocation.longitude,
                    "address": deliveryDetails.pickUpLocation.address
                }
            ],
            dropoff: [
                {
                    "postal": deliveryDetails.dropOffLocation.postalCode,
                    "name":  deliveryDetails.dropOffLocation.contactName,
                    "number": deliveryDetails.dropOffLocation.contactNumber,
                    "notes": "",
                    "floor": deliveryDetails.dropOffLocation.floor,
                    "unit": deliveryDetails.dropOffLocation.unitNumber,
                    "latitude": deliveryDetails.dropOffLocation.latitude,
                    "longitude": deliveryDetails.dropOffLocation.longitude,
                    "address": deliveryDetails.dropOffLocation.address
                }
            ]
        }
    }  

    for (let additionalStops of deliveryDetails.additionalStops) {
        requestBody.data.dropoff.push({
                    "postal": additionalStops.postalCode,
                    "name":  additionalStops.contactName,
                    "number": additionalStops.contactNumber,
                    "notes": "",
                    "floor": additionalStops.floor,
                    "unit": additionalStops.unitNumber,
                    "latitude": additionalStops.latitude,
                    "longitude": additionalStops.longitude,
                    "address": additionalStops.address
        })
    }   

    
    let response = await createNewDelivery(requestBody)
    
    return response

}

// {
//     "pickUpLocation": {
//         "postalCode": "1111111",
//         "address": "Caspian Blk 50",
//         "floor": "11",
//         "unitNumber": "11",
//         "contactName": "Lokesh",
//         "contactNumber": "91272544",
//         "latitude": 1.342484,
//         "longitude": 103.718757
//     },
//     "dropOffLocation": {
//         "postalCode": "119613",
//         "address": "Nus Enterprise Centre 21 Heng Mui Keng Terrace Nus Enterprise Centre",
//         "floor": "11",
//         "unitNumber": "12",
//         "contactName": "Lokesh",
//         "contactNumber": "91565114",
//         "latitude": 1.29226892598713,
//         "longitude": 103.776004500897
//     },
//     "additionalStops": [
//         {
//             "postalCode": "760138",
//             "address": "138 Yishun Ring Road 138 Yishun Ring Road",
//             "latitude": 1.43160991206919,
//             "longitude": 103.830614068732,
//             "floor": "11",
//             "unitNumber": "11",
//             "contactName": "Ramana",
//             "contactNumber": "91272544"
//         }
//     ],
//     "currency": "S$",
//     "tripFare": "39.10",
//     "duration": 3085,
//     "priceId": "92e593fe20a54a77b532ada4dee88c37",
//     "paymentMethod": {
//         "source": "ryde_cr_Dx7PFSb8VDMKrJ2lUeuLH9Zn",
//         "brand": "RYDE",
//         "balance": 129.9,
//         "currency": "SGD",
//         "exp": 1695361539,
//         "is_default": false
//     }
// }